"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Detail = void 0;
const react_1 = __importStar(require("react"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const lodash_1 = require("lodash");
const detail_types_1 = require("./detail-types");
const detail_hook_1 = require("./detail-hook");
const detail_context_1 = require("./detail-context");
const detail_styles_1 = require("./detail-styles");
const form_1 = require("../form/form");
const form_panel_1 = require("../form/fields/form-panel");
const react_intl_1 = require("react-intl");
const empty_component_1 = require("../../utils/empty-component");
const evidence_defaults_context_1 = require("../evidence-defaults/evidence-defaults-context");
// eslint-disable-next-line react/display-name
exports.Detail = react_1.memo(react_1.forwardRef(function Detail(options, ref) {
    const { props, context, formRef, detailContainerRef, editing } = detail_hook_1.useDetail(options, ref);
    const { ToolbarComponent, ContainerComponent: ProvidedContainerComponent, EmptyContainerComponent: ProvidedEmptyContainerComponent, FieldsComponent, GeneralFieldsComponent, toolbarProps, validationSchema, } = props;
    const { enableEmptyDetailContainer } = react_1.useContext(evidence_defaults_context_1.EvidenceDefaultsContext);
    const ContainerComponent = enableEmptyDetailContainer && context.mode === detail_types_1.DetailMode.NONE
        ? ProvidedEmptyContainerComponent
        : ProvidedContainerComponent;
    const classes = detail_styles_1.useStyles();
    return (react_1.default.createElement("div", { className: classes.outerWrapper },
        react_1.default.createElement(detail_context_1.DetailContext.Provider, { value: context },
            options.source.loading && (react_1.default.createElement("div", { className: classes.loaderWrapper },
                react_1.default.createElement(CircularProgress_1.default, { disableShrink: true, className: classes.loader }))),
            react_1.default.createElement(ToolbarComponent, Object.assign({}, toolbarProps)),
            react_1.default.createElement("div", { ref: detailContainerRef, className: classes.wrapper },
                react_1.default.createElement(form_1.Form, { ref: formRef, initialValues: {}, onSubmit: lodash_1.noop, editing: editing, validationSchema: validationSchema },
                    react_1.default.createElement(ContainerComponent, null,
                        react_1.default.createElement(FieldsComponent, null),
                        !(GeneralFieldsComponent === empty_component_1.EmptyComponent ||
                            GeneralFieldsComponent === undefined) && (react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DETAIL_TITLE", defaultMessage: "Obecn\u00E9" }) },
                            react_1.default.createElement(GeneralFieldsComponent, null)))))))));
}));
//# sourceMappingURL=detail.js.map